import { MedicalClaim, RuleHit } from './types';

export const MAX_VISIBLE_RULES = 10;
const MIN_DATE = '0000-00-00';

const getVisitDate = (claim?: MedicalClaim): string =>
  claim?.visitDate ?? MIN_DATE;

const getMostRecentDate = (
  claimIds: number[],
  claimsById: Record<number, MedicalClaim>,
): string => {
  return claimIds.reduce((latest, claimId) => {
    const claim = claimsById[claimId];
    if (!claim) {
      return latest;
    }

    const visitDate = getVisitDate(claim);
    return visitDate > latest ? visitDate : latest;
  }, MIN_DATE);
};

export const sortRuleHits = (
  ruleHits: RuleHit[],
  claimsById: Record<number, MedicalClaim>,
): RuleHit[] =>
  [...ruleHits].sort((a, b) =>
    getMostRecentDate(b.claimIds, claimsById).localeCompare(
      getMostRecentDate(a.claimIds, claimsById),
    ),
  );

export const sortedClaimsForRule = (
  claimIds: number[],
  claimsById: Record<number, MedicalClaim>,
): MedicalClaim[] => {
  return claimIds
    .map(claimId => claimsById[claimId])
    .filter((claim): claim is MedicalClaim => Boolean(claim))
    .sort((a, b) => getVisitDate(b).localeCompare(getVisitDate(a)));
};

export const sortClaimsByVisitDateDesc = (
  claims: MedicalClaim[],
): MedicalClaim[] =>
  [...claims].sort((a, b) => getVisitDate(b).localeCompare(getVisitDate(a)));

export const getAllClaims = (
  claimsById: Record<number, MedicalClaim>,
  independentClaims: MedicalClaim[],
): MedicalClaim[] => {
  const allClaimsById = new Map<number, MedicalClaim>();

  for (const claim of Object.values(claimsById)) {
    allClaimsById.set(claim.id, claim);
  }

  for (const claim of independentClaims) {
    if (!allClaimsById.has(claim.id)) {
      allClaimsById.set(claim.id, claim);
    }
  }

  return sortClaimsByVisitDateDesc(Array.from(allClaimsById.values()));
};
